import { Divider, Flex, Icon, Stack, Text, Collapse } from '@chakra-ui/react'

const SectionForm = ({ header, headerWidth = 350, icon = null, divider = 5, direction = "column", collapse = false, children, ...rest }) => {

    return (
        <Collapse in={!collapse} style={{ width: '100%' }}>
            <Flex w="full" direction="column" p={3} {...rest}>
                <Flex direction={{ base: "column", md: "row" }} w="full" align="start">
                    <Flex w={headerWidth} align="baseline">
                        {icon && <Icon as={icon} mr={1} />}
                        <Text fontWeight="bold">{header}</Text>
                    </Flex>
                    <Stack w="full" direction={direction}>
                        {children}
                    </Stack>
                </Flex>
                {divider && <Divider mt={divider} />}
            </Flex>
        </Collapse>
    )
}

export default SectionForm
